import { createSlice } from "@reduxjs/toolkit";
import {
  createCreditLineThunk,
  deleteCreditLineThunk,
  getCreditLineByIdThunk,
  getCreditLinesThunk,
  updateCreditLineThunk,
  validateCreditLineHierarchyThunk,
} from "../thunks/creditLineThunks";

const initialState = {
  creditLines: null,
  currentCreditLine: null,
  loading: false,
  error: null,
  operationSuccess: false,
};

const creditLineSlice = createSlice({
  name: "creditLine",
  initialState,
  reducers: {
    resetOperationSuccess(state) {
      state.operationSuccess = false;
    },
    setCurrentCreditLine(state, action) {
      state.currentCreditLine = action.payload;
    },
    clearCurrentCreditLine(state) {
      state.currentCreditLine = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Get All Credit Lines
      .addCase(getCreditLinesThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCreditLinesThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.creditLines = action.payload;
      })
      .addCase(getCreditLinesThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Get Credit Line by ID
      .addCase(getCreditLineByIdThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCreditLineByIdThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.currentCreditLine = action.payload;
      })
      .addCase(getCreditLineByIdThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Create Credit Line
      .addCase(createCreditLineThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.operationSuccess = false;
      })
      .addCase(createCreditLineThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.operationSuccess = true;
        state.creditLines?.push(action.payload);
      })
      .addCase(createCreditLineThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.operationSuccess = false;
      })

      // Update Credit Line
      .addCase(updateCreditLineThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.operationSuccess = false;
      })
      .addCase(updateCreditLineThunk.fulfilled, (state) => {
        state.loading = false;
        state.operationSuccess = true;
      })
      .addCase(updateCreditLineThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.operationSuccess = false;
      })

      // Delete Credit Line
      .addCase(deleteCreditLineThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.operationSuccess = false;
      })
      .addCase(deleteCreditLineThunk.fulfilled, (state) => {
        state.loading = false;
        state.operationSuccess = true;
      })
      .addCase(deleteCreditLineThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.operationSuccess = false;
      })

      // Validate CreditLine Hierarchy
       .addCase(validateCreditLineHierarchyThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(validateCreditLineHierarchyThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.validationResult = action.payload;
      })
      .addCase(validateCreditLineHierarchyThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });


  },
});

export const {
  resetOperationSuccess,
  setCurrentCreditLine,
  clearCurrentCreditLine,
} = creditLineSlice.actions;
export default creditLineSlice.reducer;
